import _ from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';
import { HeadingInContent, SectionHead } from 'src/components/cards';
import { SHOW_COMMEMORATE } from 'src/constants';
import DynamicAds, { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
const StickyBox = dynamic(import('react-sticky-box'));
const SectionPopular = dynamic(import('src/components/sections/section-popular'));
const Carousels = dynamic(import('src/components/carousels'));
const CardH = dynamic(import('src/components/cards/card-h'));
const CardV = dynamic(import('src/components/cards/card-v'));
const CardFullNoTitle = dynamic(import('src/components/cards/card-full-no-title'));

const SectionTwoAndThree = ({ ads, dataPopular }) => {
  const [sectionTwo, setSectionTwo] = useState(null);
  const [sectionThree, setSectionThree] = useState(null);
  const router = useRouter();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 690 });
  const isDesktop = useMediaQuery({ minWidth: 691 });

  useEffect(() => {
    (async () => {
      const payload = {
        block1: 5,
        block2: 5,
        block3: 5
      };
      const payloadSection3 = {
        block1: 5,
        block2: 5,
        block3: 8
      };
      const uri = `/api/v1.0/home/section-two${convertObjPath(payload)}`;
      const uriSection3 = `/api/v1.0/home/section-three${convertObjPath(payloadSection3)}`;
      try {
        const [data, dataSection3] = await Promise.all([GET(uri, false, true), GET(uriSection3, false, true)]);

        if (!_.isEmpty(data)) setSectionTwo(data);
        if (!_.isEmpty(dataSection3)) setSectionThree(dataSection3);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION_TWO ERROR : ${uri}`, err.message);
      }
    })();
  }, []);

  if (_.isEmpty(sectionTwo)) return null;
  const { block1, block2, block3 } = sectionTwo;
  const cloneBlockOneDataOne = !_.isEmpty(block1?.data) && block1?.data[0];
  const cloneBlockListI = !_.isEmpty(block1?.data) && (isDesktop ? _.slice(block1?.data, 1, 4) : _.slice(block1?.data, 1, 5));
  const cloneBlockListII = !_.isEmpty(block2?.data) && (isDesktop ? _.slice(block2?.data, 0, 5) : _.slice(block2?.data, 0, 4));
  const cloneBlockListIII = !_.isEmpty(block3?.data) && (isDesktop ? _.slice(block3?.data, 0, 5) : _.slice(block3?.data, 0, 5));
  return (
    <>
      <SectionWrapper style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
        {/* ---------------------------- BLOCK : 1 : SECTION : 2 ----------------------- */}
        {!_.isEmpty(block1?.data) && (
          <div className='block-1-section-2' id='section-3'>
            <div className='row side-main'>
              <div className='header-title'>
                <SectionHead data={block1?.title} link={block1?.link} more={true} />
              </div>
              <div className='col-md-9 side-left'>
                {!_.isEmpty(cloneBlockOneDataOne) && (
                  <CardFullNoTitle
                    data={cloneBlockOneDataOne}
                    path={cloneBlockOneDataOne?.link}
                    share={true}
                    playBtnBig={true}
                    showByline={false}
                    showTime={false}
                    showCountview={false}
                    showTitle={false}
                    //! DATALAYER
                    eventDataLayer={{
                      type: DATALAYER_TYPE.TRACK_INDEX,
                      router: router?.pathname,
                      section: 'section-3',
                      data: {
                        block: '1',
                        title: cloneBlockOneDataOne?.title,
                        heading: block1?.title,
                        index: 1
                      }
                    }}
                  />
                )}
              </div>
              <div className='col-md-3 side-right'>
                {!_.isEmpty(block1?.data) && (
                  <div className='row card-list'>
                    {cloneBlockListI.map((item, index) => (
                      <div key={index} className='card-item col-6 col-md-12'>
                        <CardFullNoTitle
                          data={item}
                          path={item?.link}
                          share={true}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_INDEX,
                            router: router?.pathname,
                            section: 'section-3',
                            data: {
                              block: '2',
                              title: item?.title,
                              heading: block1?.title,
                              index: index + 1
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* ---------------------------- SECTION : POPULAR ----------------------- */}
        {!_.isEmpty(dataPopular) && <SectionPopular data={dataPopular} />}
        {/* ---------------------------- BLOCK : 2 : SECTION : 2 ----------------------- */}
        <div className='container block-2-3-section-2-section-3-blcok-1-2' id='section-5'>
          <div className='row'>
            <div className='block-2-section-2 col-12 col-lg-3'>
              {!_.isEmpty(block2?.data) && (
                <StickyBox offsetTop={30} offsetBottom={30}>
                  <>
                    <SectionHead data={block2?.title} link={block2?.link} />
                    <div className='row card-list'>
                      {cloneBlockListII.map((item, index) => (
                        <>
                          {isDesktop && (
                            <div key={index} className='mb-15 col-12 col-md-6 col-lg-12'>
                              <CardH
                                data={item}
                                pinTag={false}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_INDEX,
                                  router: router?.pathname,
                                  section: 'section-5',
                                  data: {
                                    block: '1',
                                    title: item?.title,
                                    heading: block1?.title,
                                    index: index + 1
                                  }
                                }}
                              />
                            </div>
                          )}

                          {isTabletOrMobile && (
                            <div key={index} className='col-6 card-list-v'>
                              <CardV
                                data={item}
                                // pinTag={false}
                                //! DATALAYER
                                // eventDataLayer={{
                                //   type: DATALAYER_TYPE.TRACK_INDEX,
                                //   router: router?.pathname,
                                //   section: 'section-5',
                                //   data: {
                                //     block: '1',
                                //     title: cloneBlockOneDataOne?.title,
                                //     heading: block1?.title,
                                //     index: 1
                                //   }
                                // }}
                              />
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  </>
                </StickyBox>
              )}
            </div>

            {/* --------------------------------- BLOCK : 3 : SECTION : 2 -------------------------------- */}
            <div className='block-3-section-2 col-12 col-lg-6'>
              {!_.isEmpty(block3?.data) && (
                <>
                  <SectionHead data={block3.title} link={block3.link} />
                  <div className='row'>
                    {cloneBlockListIII.map((item, index) => (
                      <div key={index} className='border-item col-12 col-lg-12 card-list'>
                        <CardV
                          data={item}
                          showBlurb={true}
                          pinTag={true}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_INDEX,
                            router: router?.pathname,
                            section: 'section-5',
                            data: {
                              block: isDesktop ? '2' : '1',
                              title: item?.title,
                              heading: block3?.title,
                              index: index + 1
                            }
                          }}
                        />
                      </div>
                    ))}
                    {/* ---------------------- ADS : PPN - INARTICLE_3 [DESKTOP]-------------------- */}
                    {isDesktop && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}
                  </div>
                </>
              )}
            </div>
            {!_.isEmpty(sectionThree) && (
              <div className='col-12 col-lg-3 mt-30 mt-lg-0'>
                <StickyBox offsetTop={30} offsetBottom={50}>
                  {/* --------------------------------- BLOCK : 1 : SECTION : 3 -------------------------------- */}
                  {!_.isEmpty(sectionThree?.block1?.data) && (
                    <div className='block-2'>
                      <SectionHead data={sectionThree?.block1?.title} link={sectionThree?.block1?.link} />
                      <Carousels
                        infinite={sectionThree?.block1?.data.length >= 2}
                        dots={false}
                        slideShow={1}
                        autoplaySpeed={5000}
                        mobileSlideShow={sectionThree?.block1?.data?.length > 1 ? 2 : 1}
                      >
                        {sectionThree?.block1?.data.map((item, index) => (
                          <div key={index}>
                            <CardV
                              data={item}
                              pinTag={false}
                              path={item?.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_INDEX,
                                router: router?.pathname,
                                section: 'section-5',
                                data: {
                                  block: isDesktop ? '3' : '2',
                                  title: item?.title,
                                  heading: sectionThree?.block1?.title,
                                  carousel: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </Carousels>
                    </div>
                  )}
                  {isTabletOrMobile && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}

                  {/* --------------------------------- BLOCK : 2 : SECTION : 3-------------------------------- */}
                  {!_.isEmpty(sectionThree?.block2?.data) && (
                    <>
                      <div className='block-3'>
                        <SectionHead data={sectionThree?.block2?.title} link={sectionThree?.block2?.link} />
                        <Carousels dots={false} slideShow={1} mobileSlideShow={sectionThree?.block2?.data?.length > 1 ? 2 : 1}>
                          {sectionThree?.block2?.data?.map((item, index) => (
                            <div key={index}>
                              <CardV
                                data={item}
                                pinTag={false}
                                path={item?.link}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_INDEX,
                                  router: router?.pathname,
                                  section: 'section-5',
                                  data: {
                                    block: isDesktop ? '4' : '3',
                                    title: item?.title,
                                    heading: sectionThree?.block1?.title,
                                    carousel: index + 1
                                  }
                                }}
                              />
                            </div>
                          ))}
                        </Carousels>
                        {/* ---------------------- ADS : PPN - STICKY_2 -------------------- */}
                        <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />
                      </div>
                    </>
                  )}
                </StickyBox>
              </div>
            )}
          </div>
        </div>
        {/* --------------------------------- BLOCK : 3 : SECTION : 3-------------------------------- */}
        {!_.isEmpty(sectionThree?.block3?.data) && (
          <div className='block-3-section-3' id='section-6'>
            <HeadingInContent data={sectionThree?.block3?.title} link={sectionThree?.block3?.link} />
            <div className='row card-list'>
              {isDesktop && (
                <>
                  {sectionThree?.block3?.data?.map((item, index) => (
                    <div key={index} className='card-item col-6 col-md-3'>
                      <CardV
                        data={item}
                        share={false}
                        pinTag={false}
                        showByline={false}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-6',
                          data: {
                            title: item?.title,
                            heading: sectionThree?.block3?.title,
                            index: index + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </>
              )}
              {isTabletOrMobile && (
                <>
                  {sectionThree?.block3?.data?.slice(0, 4)?.map((item, index) => (
                    <div key={index} className='card-item col-6 col-md-3'>
                      <CardV
                        data={item}
                        share={false}
                        pinTag={false}
                        showByline={false}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-6',
                          data: {
                            title: item?.title,
                            heading: sectionThree?.block3?.title,
                            index: index + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        )}
      </SectionWrapper>
    </>
  );
};

const SectionWrapper = styled.section`
  position: relative;
  display: block;
  .block-1-section-2 {
    padding: 30px 0;
    background: #f0f0f0;
    /* @media (max-width: 767px) {
      padding: 30px;
    } */
    .section-head {
      position: relative;
      .more {
        text-transform: uppercase;
        position: absolute;
        top: 0;
        right: 0;
        background-color: #f0f0f0;
        padding: 0 0 0 10px;
        @media (max-width: 767px) {
          background: rgb(255, 224, 0);
          background: linear-gradient(270deg, rgba(255, 224, 0, 1) 90%, rgba(240, 240, 240, 1) 90%);
          padding: 0px 10px;
          margin: 6px 0;
          display: flex;
        }
        a {
          font-size: 18px;
          font-weight: 400;
          @media (max-width: 767px) {
            font-size: 12px;

            margin-left: 10px;
            letter-spacing: 1.2px;
          }
        }
      }
    }
    .side-main {
      .border-item {
        padding: 0;
        margin: 0;
      }
      .header-title {
        max-width: 1360px;
        margin: 0 auto;
        padding: 0 30px;
        /* padding-left: 30px;
        padding-right: 30px; */
      }
      @media (min-width: 769px) {
        padding-left: 0;
        max-width: 1360px;
        margin: 0 auto;
        padding-left: 30px;
        padding-right: 30px;
        .header-title {
          padding: 0;
        }
      }
      @media (max-width: 767px) {
        padding-left: 0;
        max-width: 100%;
        margin: 0 auto;
        /* padding-left: 30px;
        padding-right: 30px; */
      }
    }
    .side-left {
      padding-right: 15px;
      @media (max-width: 768px) {
        padding-right: 0;
      }
    }
    .side-right {
      padding-left: 15px;
      @media (max-width: 768px) {
        padding: 0 30px;
        max-width: 1360px;
        margin: 0 auto;
        .share-card,
        .video-card-share {
          display: none;
        }
      }
      @media (max-width: 480px) {
        .byline {
          display: none;
        }
      }
      .card-list {
        @media (max-width: 768px) {
          margin: 0 -10px;
        }
        .card-item {
          margin-bottom: 15px;
          @media (min-width: 768px) {
            .card-content {
              display: none;
            }
          }
          @media (max-width: 767px) {
            margin-top: 28px;
            margin-bottom: 0;
            padding: 0 10px;
          }
          &:last-child {
            margin-bottom: 0;
          }
          .border-item {
            padding-bottom: 28px;
            border-bottom: 1px solid rgba(120, 120, 120, 0.1);
            @media (max-width: 767px) {
              h3 {
                font-size: 16px;
              }
            }
            @media (min-width: 768px) {
              border-bottom: none;
              padding-bottom: 0;
            }
            h3 {
              margin: 16px 0;
              line-height: 1.4;
            }
          }
        }
      }
    }
  }

  .block-2-3-section-2-section-3-blcok-1-2 {
    padding-top: 38px;
    position: relative;
    .block-2-section-2 {
      @media (max-width: 768px) {
        order: 3;
      }
      @media (max-width: 690px) {
        .card-list {
          margin: 0 -10px;
          padding: 0 0 32px 0;
          .card-list-v {
            padding: 0 10px;
            .border-item {
              border-bottom: 1px solid rgba(120, 120, 120, 0.1);
              padding: 0 0 24px 0;
              margin-bottom: 24px;
              .card-thumb .img-scale-animate .share-card {
                display: none;
              }
            }
          }
        }
      }
      @media (max-width: 480px) {
        .byline {
          display: none;
        }
      }
    }

    .block-3-section-2 {
      padding: 0 0 0 30px;
      .border-item {
        margin-bottom: 38px;
        @media (max-width: 690px) {
          margin-bottom: 20px;
        }
        &.card-list {
          padding: 0;
        }
        @media (max-width: 768px) {
          &:not(:nth-child(1)) {
            &.card-list {
              .border-item {
                margin-bottom: 0;
                border-bottom: 1px solid rgba(120, 120, 120, 0.1);
                padding: 0 0 20px 0;
              }
            }
          }
        }
        @media (max-width: 480px) {
          &:not(:nth-child(1)) {
            .byline {
              display: none;
            }
          }
        }
      }

      .card-content {
        h3 {
          font-size: 28px;
          font-weight: 500;
        }
        .byline {
          color: #000000;
        }
      }
      @media (max-width: 768px) {
        padding: 0 0 0 0;
        .border-item {
          &:nth-child(1) {
            .card-content {
              h3 {
                -webkit-line-clamp: 3;
                font-size: 20px;
              }
            }
          }
          &:not(:nth-child(1)) {
            border: none;
            padding: 0;
            width: 50%;
            .card-content {
              h3 {
                -webkit-line-clamp: 3;
                font-size: 16px;
              }
            }
          }
          &:nth-child(2) {
            padding-right: 10px;
          }
          &:nth-child(3) {
            padding-left: 10px;
          }
          &:nth-child(4) {
            padding-right: 10px;
          }
          &:nth-child(5) {
            padding-left: 10px;
          }
        }
      }
      @media (max-width: 690px) {
        .card-thumb .img-scale-animate .share-card {
          display: none;
        }

        .blurb {
          display: none;
        }
      }
    }

    .block-2,
    .block-3 {
      position: relative;
      padding: 0 0 0 30px;
      @media (max-width: 768px) {
        padding: 0 0 0 0;
      }
      .slick-slider {
        position: static;
        .slide-arrow,
        .slick-arrow {
          display: block !important;
          background-color: #fff;
          border: none;
          position: absolute;
          padding-left: 5px;
          top: 16px;
          right: 0;
        }
        .next-arrow,
        .slick-next,
        .prev-arrow,
        .slick-prev {
          z-index: 1;
          font-size: unset;
          width: unset;
          height: unset;
          &:before {
            content: unset;
          }
          cursor: pointer;
          svg {
            vertical-align: middle;
            color: #000;
          }
        }
        .prev-arrow,
        .slick-prev {
          right: 20px;
          left: unset;
          z-index: 2;
          &:after {
            content: '/';
            padding-left: 5px;
            color: #a0a0a0;
            vertical-align: middle;
          }
        }
      }
      @media (max-width: 690px) {
        .slick-slider {
          position: relative;
          .slide-arrow,
          .slick-arrow {
            background-color: #000;
            position: relative;
            padding: 14px;
          }
          .next-arrow,
          .slick-next,
          .prev-arrow,
          .slick-prev {
            position: absolute;
            top: 30%;
            transform: translate(0, -30%);
            svg {
              vertical-align: middle;
              polyline {
                stroke: var(--primary-color);
              }
            }
          }
          .next-arrow,
          .slick-next {
            right: -2px;
          }
          .prev-arrow,
          .slick-prev {
            right: unset;
            left: -2px;
            z-index: 1;
            &:after {
              content: '';
            }
          }
        }
      }
      .card-v {
        h3 {
          font-size: 18px;
          line-height: 1.45;
          /* font-weight: 400; */
        }
        .byline {
          color: #000000;
        }
      }
      @media (max-width: 992px) {
        .custom-carousel {
          margin: 0 -15px;
        }
        .card-v {
          .card-content {
            border-bottom: 1px solid rgba(120, 120, 120, 0.1);
            padding: 0 0 25px 0;
          }
          padding: 0 15px;
        }
      }
    }
  }

  .block-3-section-3 {
    position: relative;
    padding: 38px 0 0 0;
    @media (max-width: 690px) {
      padding: 0 0 0 0;
    }
    .heading {
      position: absolute;
      top: 10%;
      left: 50%;
      transform: translate(-50%, -10%);
      z-index: 1;
      text-transform: uppercase;
      h2 {
        font-size: 48px;
        font-weight: 700;
        filter: drop-shadow(2px 3px 2px #000);
        a {
          color: #fff;
        }
        @media (max-width: 690px) {
          font-size: 24px;
        }
      }
      p {
        background-color: var(--primary-color);
        padding: 2px 16px;
        font-size: 12px;
        font-weight: 400;
        width: fit-content;
        margin: auto;
        transition: all 0.4s ease-in-out;
        &:hover {
          background-color: #fff;
          color: var(--primary-color);
        }
        @media (max-width: 690px) {
          padding: 2px 15px;
          font-size: 10px;
        }
      }
    }
    .card-v {
      padding: 0;
      margin: 0;
      .share-card {
        display: none;
      }
      .resolution-image {
        padding-top: 75% !important;
        /* 4/3 */
      }
      .card-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        position: absolute;
        width: 100%;
        height: 50%;
        bottom: 0;
        padding: 0 16px;
        background: rgb(0, 0, 0);
        background: linear-gradient(0deg, rgb(0 0 0 / 0.8) 5%, rgba(255, 255, 255, 0) 100%);
        @media (max-width: 690px) {
          flex-direction: column-reverse;
          height: auto;
          padding-bottom: 10px;
        }

        h3 {
          font-size: 16px;
          font-weight: 400;
          margin: 0 0 6px 0;
          min-height: 0;
          color: #fff;
          -webkit-line-clamp: 1;
          width: 580px;
          max-width: 100%;
          @media (max-width: 690px) {
            font-size: 14px;
            margin: 0;
          }
        }
        .meta-contents {
          margin: 0;
          padding: 8px 5px;
          justify-content: flex-end;
          @media (max-width: 690px) {
            padding: 0;
          }
          .meta {
            justify-content: flex-end;
            @media (max-width: 690px) {
              justify-content: flex-start;
            }
          }
          p,
          span,
          svg {
            color: rgba(256, 256, 256, 0.8);
          }
          .read-more {
            display: none;
          }
        }
      }
    }
  }
`;

export default SectionTwoAndThree;
